<template>
  <span>{{ emptyValue }}</span>
</template>

<script setup lang="ts">
const { emptyValue = "-" } = defineProps<{
  emptyValue?: string
}>()
</script>
